import ioc from '@Framework/ioc';
const API_PATH = '/register-issue';
async function registerIssue(formData) {
    const requestManager = ioc.get('service.requestManager');
    return await requestManager.post(process.env.VUE_APP_API_URL, API_PATH, formData);
}
export default {
    registerIssue,
};
